function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M3.67547 4.50007L0.171046 0.995468C-0.0570154 0.767509 -0.0570154 0.398929 0.171046 0.17097C0.399001 -0.0569899 0.767572 -0.0569899 0.995527 0.17097L4.50005 3.67557L8.00447 0.17097C8.23253 -0.0569899 8.601 -0.0569899 8.82895 0.17097C9.05702 0.398929 9.05702 0.767509 8.82895 0.995468L5.32453 4.50007L8.82895 8.00467C9.05702 8.23263 9.05702 8.6012 8.82895 8.82916C8.71535 8.94288 8.56598 9 8.41671 9C8.26745 9 8.11818 8.94288 8.00447 8.82916L4.50005 5.32456L0.995527 8.82916C0.881817 8.94288 0.732553 9 0.583287 9C0.434022 9 0.284757 8.94288 0.171046 8.82916C-0.0570154 8.6012 -0.0570154 8.23263 0.171046 8.00467L3.67547 4.50007Z",
  fill: "#000"
});

var SvgCross = function SvgCross(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 9 9",
    fill: "#000",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCross, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cross.4d98b18c.svg";
export { ForwardRef as ReactComponent };